import BaseApiAction from '@Actions/base-api-action';

export default class SecureDeleteTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'secure-secureDeleteTeam',
      payload: {
        secure_key: this._payload.secure_key,
        team_id: this._payload.team_id,
      },
    });
  }

  onSuccess(data) {
    this._state.admin.teams.events.teamDeleted.emit();
    super.onSuccess(data);
  }
}
